import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http'
import { catchError, Observable, throwError } from 'rxjs'
import { inject } from '@angular/core'
import { ToastService } from '@shared/services/toast.service'
import { AuthService } from '@app/core'

export const errorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const toastService = inject(ToastService)
  const authService = inject(AuthService)

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      toastService.show('error', 'Error ' + error.status, error.error.message + '')

      switch (error.status) {
        // display error in form
        case 400:
          break

        // unauthorized => logout
        case 401: {
          authService.logout(true).subscribe({
            error: error => {
              console.error('Logout failed:', error)
            },
          })
          break
        }
        // forbidden => display toast error
        case 403: {
          break
        }
        // not found => display toast error
        case 404: {
          break
        }
        // 500 error
        default: {
          // erreur ignorée volontairement : le toast d'erreur est déjà affiché ci-dessus
        }
      }

      return throwError(() => error)
    })
  )
}
